export default "__VITE_ASSET__C5blH3yy__"